import type { TrialReport } from '@sine/sine-core-api-types';

import { authHelpers } from '../authentication/auth.service';
import billingService from '../services/billing/billing.service';
import type { PendoConfigData, TeamData, UserData } from './pendo.types';
import { identifyPendo, initializePendo, isPendoReady } from './pendoMethods';

const NO_TEAM_ID = '1';
const NO_TEAM = 'No Team';

export class PendoService {
  constructor() {}

  async configurePendoData(userData: UserData, teamData: TeamData | undefined) {
    const userBillingData: TrialReport | null = teamData ? await billingService.getTrialData() : null;
    const { id, name, ...flags } = teamData ?? { id: undefined, name: undefined };

    const pendoConfig: PendoConfigData = {
      visitor: {
        id: userData.id,
        email: userData.email,
        first_name: userData.firstName,
        last_name: userData.lastName,
        company: userData.company,
        isTeamOwner: userData.isTeamOwner,
        permissions: userData.permissions,
        teams: userData.teams,
      },
      account: {
        id: id || NO_TEAM_ID,
        name: name || NO_TEAM,
        ...flags,
      },
    };
    if (userBillingData) {
      pendoConfig.account.numOfLicences = userBillingData.numOfLicences;
      pendoConfig.account.numOfSites = userBillingData.numOfSites;
      pendoConfig.account.numOfUnlicensedSites = userBillingData.numOfUnlicensedSites;
      pendoConfig.account.onTrial = userBillingData.onTrial ? 'In Trial' : 'Trial Ended';

      if (userBillingData.siteOnTrial) {
        pendoConfig.account.siteOnTrial = userBillingData.siteOnTrial.name;
      }
    }

    return pendoConfig;
  }

  async initializePendoMetadata(userData: UserData, teamData: TeamData | undefined) {
    if (window.env.REACT_APP_PENDO_CLIENT_KEY && !authHelpers.isImpersonating()) {
      const pendoConfig = await this.configurePendoData(userData, teamData);
      await initializePendo(pendoConfig);
    }
  }

  async identifyPendoMetadata(userData: UserData, teamData: TeamData | undefined) {
    if (window.env.REACT_APP_PENDO_CLIENT_KEY && (await isPendoReady())) {
      const pendoConfig = await this.configurePendoData(userData, teamData);
      identifyPendo(pendoConfig);
    }
  }
}
const pendoService = new PendoService();
export default pendoService;
